import React, { useEffect, useRef, useState } from "react";
import classnames from "classnames";
import { gettext } from "web/script/modules/django-i18n";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./member-benefits-carousel.css";

export default function MemberBenefitsCarousel(): JSX.Element {
    const listContainerRef = useRef<HTMLDivElement>(null);
    const [benefitProgressCounter, setBenefitProgressCounter] = useState<number>(1);

    useEffect(() => {
        if (listContainerRef.current === null) {
            return;
        }

        const listContainer = listContainerRef.current;

        let counter = 0;
        let previousStyle = "";
        const benefitStyles = [styles.firstBenefit, styles.secondBenefit, styles.thirdBenefit];

        const carousel = setInterval(() => {
            setBenefitProgressCounter(counter + 1);

            if (listContainer.classList.contains(previousStyle)) {
                listContainer.classList.remove(previousStyle);
            }

            listContainer.classList.add(benefitStyles[counter]);

            previousStyle = benefitStyles[counter];

            if (counter === 2) {
                counter = 0;
            } else {
                counter += 1;
            }
        }, 3000);

        return (): void => {
            clearInterval(carousel);
        };
    }, []);

    return (
        <div className={styles.benefitsCarouselContainer}>
            <div className={styles.counterContainer}>
                <div className={styles.counterText}>
                    <span>{`${benefitProgressCounter} / 3`}</span>
                </div>
            </div>
            <div ref={listContainerRef} className={styles.benefitsListContainer}>
                <ul>
                    <li>
                        <div className={styles.iconContainer}>
                            <SVGIcon
                                name={"searches-icon-empty"}
                                className={classnames(styles.icon, styles.saveIcon)}
                            />
                            <SVGIcon
                                name={"searches-icon-filled"}
                                className={classnames(
                                    styles.icon,
                                    styles.saveIcon,
                                    styles.saveIconFilled
                                )}
                            />
                        </div>
                        <span className={styles.benefitText}>
                            {gettext("member_signup.member_overlay.carousel_title_1")}
                        </span>
                    </li>
                    <li>
                        <div className={styles.iconContainer}>
                            <SVGIcon
                                name={"heart-icon-empty"}
                                className={classnames(styles.icon, styles.heartIcon)}
                            />
                            <SVGIcon
                                name={"heart-icon-filled"}
                                className={classnames(
                                    styles.icon,
                                    styles.heartIcon,
                                    styles.heartIconFilled
                                )}
                            />
                        </div>
                        <span className={styles.benefitText}>
                            {gettext("member_signup.member_overlay.carousel_title_2")}
                        </span>
                    </li>
                    <li>
                        <div className={styles.iconContainer}>
                            <SVGIcon
                                name={"bell-empty"}
                                className={classnames(styles.icon, styles.bellIcon)}
                            />
                        </div>
                        <span className={styles.benefitText}>
                            {gettext("member_signup.member_overlay.carousel_title_3")}
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    );
}
